var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHome = function SvgIconHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#060D26",
    d: "M22.25 13.58v2.136c0 1.81 0 2.714-.231 3.448a5 5 0 0 1-3.265 3.265c-.734.231-1.64.231-3.448.231-.073 0-.109 0-.138-.01a.2.2 0 0 1-.131-.13c-.01-.03-.01-.065-.01-.138V18.31a2.778 2.778 0 0 0-5.555 0v4.073c0 .073 0 .109-.009.138a.2.2 0 0 1-.13.13c-.03.01-.066.01-.139.01-1.809 0-2.714 0-3.447-.231a5 5 0 0 1-3.266-3.265c-.231-.734-.231-1.639-.231-3.448v-2.137c0-1.082 0-1.624.165-2.101.147-.422.386-.806.7-1.124.354-.36.84-.6 1.81-1.079l5.909-2.916c.52-.256.78-.385 1.051-.435a2 2 0 0 1 .73 0c.272.05.532.179 1.051.435l5.908 2.916c.971.48 1.457.719 1.812 1.079.313.318.552.702.698 1.124.166.477.166 1.019.166 2.101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#060D26",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m22.25 8.245-8.521-4.44c-.542-.282-.812-.423-1.097-.478a2 2 0 0 0-.764 0c-.285.055-.555.196-1.096.478L2.25 8.245"
  })));
};
export default SvgIconHome;